import InvestmentCalculator from "../../components/InvestmentCalculator";
import MemberSurfacePreview from "../landing/MemberSurfacePreview";

export function MembershipBuyers({ assets }) {
  return (
    <>
      <section className="hairline mt-4 pt-16 rise" data-testid="membership-buyers">
        <span className="t-label">For buyers</span>
        <p className="t-body text-bone mt-4 measure">
          Verified members see their portfolio, deal memos, documents and member to member transfers. Nothing
          is public and every memo states what we do not know.
        </p>
      </section>

      <MemberSurfacePreview />

      <section className="hairline py-16 rise" data-testid="membership-calculator">
        <span className="t-label">Model the outcome</span>
        <h2 className="t-h2 text-bone mt-3 max-w-2xl">See what an early position could have become.</h2>
        <div className="mt-10">
          {assets === null ? (
            <p className="t-label">Loading</p>
          ) : (
            <InvestmentCalculator assets={assets} testid="membership-calc" />
          )}
        </div>
      </section>
    </>
  );
}
